module.exports = __webpack_public_path__ + "static/media/logo-danone.17c4edda.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-danone.png
// module id = 247
// module chunks = 0